import React from 'react';
import { /*Outlet,*/ Navigate } from 'react-router-dom';

import AuthService from './AuthService';

// const ProtectedRoute = ({ component: Component, ...rest }) => {
//   const user = AuthService.getCurrentUser();

//   return (
//     <Route
//       {...rest}
//       render={(props) =>
//         user ? <Component {...props} /> : <Navigate to="/login5" />
//       }
//     />
//   );
// };


const ProtectedRoute = ({ children }) => {
    const user = AuthService.getCurrentUser();

    return user ? children : <Navigate to="/" />;
  }

export default ProtectedRoute;